import React from 'react'
import PropTypes from 'prop-types'
import { logErrorToRollbar } from '@jarvis.oddle/core/tools/rollbarHelper'
/*
Note: ErrorBoundary do not catch errors for:
- Event handlers
- Asynchronous code (e.g. setTimeout or requestAnimationFrame callbacks)
- Server side rendering
- Errors thrown in the error boundary itself (rather than its children)
*/
class ErrorBoundary extends React.Component {
  static propTypes = {
    getErrorMessage: PropTypes.func,
    renderError: PropTypes.func
  }

  static defaultProps = {
    getErrorMessage: x => x,
    renderError: () => null
  }

  state = {
    hasError: false
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error }
  }

  componentDidCatch (error, info) {
    const { getErrorMessage } = this.props
    const err = getErrorMessage({ error, info })

    logErrorToRollbar(err, window.location.href)

    // Always log errors to the console
    console.error(err)
  }

  render () {
    const { renderError } = this.props
    const { hasError, error } = this.state

    if (hasError) return renderError(error)

    return this.props.children
  }
}

export default ErrorBoundary
